import ColorfulText from './colorful-text';
export default ColorfulText;
